import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { BehaviorSubject, Observable, finalize } from "rxjs";
import { environment } from "../../environments/environment";
import { ArmamentType } from "../models/shared-component/armament-type";
import { MasterAttachment } from "../models/shared-component/attachment.model";
import { Classes } from "../models/shared-component/class";
import { Department } from "../models/shared-component/department";
import { District } from "../models/shared-component/district";
import { Division } from "../models/shared-component/division";
import { Dropdown } from "../models/shared-component/drop-down.model";
import { EquipmentType } from "../models/shared-component/equipment-type";
import { Field } from "../models/shared-component/field";
import { FieldGroup } from "../models/shared-component/field-group";
import { FiscalYear } from "../models/shared-component/fiscal-year";
import { Gender } from "../models/shared-component/gender";
import { MainArmamentCategory } from "../models/shared-component/main-armament-category";
import { MainVehicalType } from "../models/shared-component/main-vehical-type";
import { MaterialType } from "../models/shared-component/material-type";
import { Organization } from "../models/shared-component/organization";
import { Position } from "../models/shared-component/position";
import { ProcurementType } from "../models/shared-component/procurement-type";
import { Province } from "../models/shared-component/province";
import { Rank } from "../models/shared-component/rank";
import { SubArmamentCategory } from "../models/shared-component/sub-armament-category";
import { Subdistrict } from "../models/shared-component/subdistrict";
import { Subdivision } from "../models/shared-component/subdivision";
import { Unit } from "../models/shared-component/units";



@Injectable({
  providedIn: "root",
})

export class ShareService {

  isLoading$: Observable<boolean>;
  isLoadingSubject: BehaviorSubject<boolean>;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private fb: FormBuilder,
    private http: HttpClient
  ) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
    this.isLoading$ = this.isLoadingSubject.asObservable();
  }

  tierList = [
    { value: 1, label: 'สง.ผบ.ตร' } as Dropdown,
    { value: 2, label: 'สง. รอง ผบ.ตร.' } as Dropdown,
    { value: 3, label: 'สง. ผู้ช่วย ผบ.ตร.' } as Dropdown,
    { value: 4, label: 'ผบช. ประจำ สง.ผบ.ตร.' } as Dropdown,
    { value: 5, label: 'รอง ผบช. ประจำ สง.ผบ.ตร.' } as Dropdown,
    { value: 6, label: 'กองบัญชาการ' } as Dropdown,
    { value: 7, label: 'กองบังคับการ' } as Dropdown,
    { value: 8, label: 'กองกำกับการ' } as Dropdown,
    { value: 11, label: 'กองกำกับการ (ส่วนป้องกันและปราบปรามอาชญากรรม)' } as Dropdown,
    { value: 9, label: 'กองบังคับการตำรวจนครบาล และตำรวจภูธรจังหวัด' } as Dropdown,
    { value: 10, label: 'สถานีตำรวจ' } as Dropdown,
  ];

  tierListChild = this.tierList.filter(f => f.value > 6);

  typeList = [
    { value: 1, label: 'สถานีตำรวจทั่วไป' } as Dropdown,
    { value: 2, label: 'สถานีตำรวจในพื้นที่ 3 จังหวัดชายแดนใต้ และ 4 อำเภอของสงขลา' } as Dropdown,
    { value: 3, label: 'ศูนย์ฝึกอบรม' } as Dropdown,
    { value: 4, label: 'หน่วยปฏิบัติการพิเศษ EOD' } as Dropdown,
    { value: 5, label: 'หน่วยปฏิบัติการพิเศษ นปพ.' } as Dropdown,
    { value: 6, label: 'ตรวจคนเข้าเมือง' } as Dropdown,
    { value: 7, label: 'ศูนย์พิสูจน์หลักฐาน' } as Dropdown,
    { value: 8, label: 'โรงพยาบาล' } as Dropdown,
    { value: 9, label: 'สันติบาล' } as Dropdown,
    { value: 9, label: 'ตำรวจตระเวนชายแดน' } as Dropdown
  ];

  stationSizeList = [
    { value: 1, label: 'สถานีย่อย' } as Dropdown,
    { value: 2, label: 'สถานีขนาดเล็กพิเศษ' } as Dropdown,
    { value: 3, label: 'สถานีขนาดเล็ก' } as Dropdown,
    { value: 4, label: 'สถานีขนาดกลาง' } as Dropdown,
    { value: 5, label: 'สถานีขนาดใหญ่' } as Dropdown,
    { value: 6, label: 'สถานีขนาดใหญ่พิเศษ' } as Dropdown
  ];

  immigrationSizeList = [
    { value: 1, label: 'ระดับสารวัตร' } as Dropdown,
    { value: 2, label: 'ระดับผู้กำกับการ' } as Dropdown,
  ];

  evidenceCenterSizeList = [
    { value: 1, label: 'ระดับจังหวัด' } as Dropdown,
    { value: 2, label: 'ระดับศูนย์ภาค' } as Dropdown,
  ];

  otherSizeList = [
    { value: 1, label: 'ระดับ สว.' } as Dropdown,
    { value: 2, label: 'ระดับ กองกำกับการ' } as Dropdown,
    { value: 3, label: 'ระดับ กองบังคับการ' } as Dropdown,
    { value: 4, label: 'ระดับ กองบัญชาการ' } as Dropdown,
  ];

  activeTypeList = [
    { value: 1, label: 'ใช้งาน.' } as Dropdown,
    { value: 2, label: 'ไม่ใช้งาน' } as Dropdown,
  ]

  areaTypeList = [
    { value: 1, label: 'ติดน้ำ' } as Dropdown,
    { value: 2, label: 'ติดชายทะเล' } as Dropdown,
    { value: 3, label: 'ติดพื้นที่เขา' } as Dropdown,
    { value: 4, label: 'อุทกภัยซ้ำซาก' } as Dropdown,
    { value: 5, label: 'ติดแม่น้ำ' } as Dropdown,
    { value: 6, label: 'พื้นที่ชายทะเลและป่าเขา' } as Dropdown
  ]

  fieldTypeList = [
    { value: 1, label: 'สายงานปฏิบัติการป้องกันปราบปราม' } as Dropdown,
    { value: 2, label: 'สายงานจราจร' } as Dropdown,
    { value: 3, label: 'สายงานบริหารงานป้องกันปราบปราม' } as Dropdown,
    { value: 4, label: 'สายงานปฏิบัติการป้องกันปราบปรามทางน้ำ' } as Dropdown,
    { value: 5, label: 'สายงานต่อต้านการก่อการร้าย' } as Dropdown,
    { value: 6, label: 'สายงานสืบสวนสอบสวน' } as Dropdown,
    { value: 7, label: 'สายงานสืบสวน' } as Dropdown,
    { value: 8, label: 'สายงานบริหารงานสืบสวนสอบสวน' } as Dropdown,
  ]

  officeEquipmentTypeList = [
    { value: 1, label: 'ไม่กำหนดขั้นต่ำ' } as Dropdown,
    { value: 2, label: 'ประจำหน่วยงาน' } as Dropdown,
    { value: 3, label: 'ตามจำนวนอัตรากำลังในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 4, label: 'ประจำครุภัณฑ์' } as Dropdown,
    { value: 5, label: 'ตามจำนวนคนครองในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 6, label: 'ห้องที่ติดตั้งเครื่องปรับอากาศ' } as Dropdown,
    { value: 7, label: 'ประจำห้องประชุม' } as Dropdown,
    //{ value: 8, label: 'ประจำฝ่าย/กก. ใต้สังกัด ยกเว้นสถานีตำรวจ' } as Dropdown,
    //{ value: 9, label: 'ประจำงาน' } as Dropdown,
    //{ value: 10, label: 'ประเภทงาน' } as Dropdown,
    //{ value: 11, label: 'จำนวนห้องตามขนาด' } as Dropdown,
    { value: 12, label: 'จำนวนห้องประชุม' } as Dropdown,
    { value: 13, label: 'จำนวนเจ้าหน้าที่สายปฎิบัติการ' } as Dropdown,
    { value: 14, label: 'หน่วยงานที่มีหน่วยงานย่อยในสังกัด หรือออกปฏิบัติงานเป็นทีม ประจำทีม' } as Dropdown,
    { value: 15, label: 'มีกิจกรรมในสถานที่โล่งแจ้ง' } as Dropdown,
    { value: 16, label: 'หน่วนงานที่มีหน้าที่ออกไปปฎิบัติสายปฎิบัติการ ตามจำนวนยานพาหนะ' } as Dropdown,
    { value: 17, label: 'จำนวนชั้นของอาคารสำนักงาน' } as Dropdown,
    { value: 18, label: 'ประจำสายงาน (ประจำงาน)' } as Dropdown,
    { value: 19, label: 'ประจำตัวเจ้าหน้าที่เวรยาม' } as Dropdown,
    { value: 20, label: 'ตามภารกิจ' } as Dropdown,
    { value: 21, label: 'ตามจำนวนคนครองแต่ละสายงาน' } as Dropdown,
    { value: 22, label: 'ตามจำนวนอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 23, label: 'ร้อยละคนครองแต่ละสายงาน' } as Dropdown,
    { value: 24, label: 'ร้อยละอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 25, label: 'ประจำยานพาหนะ' } as Dropdown,
  ]

  getOfficeEquipmentTypeDetail(index: number): string {
    var getValue = this.officeEquipmentTypeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  MstEquipmentQuotaTypeList = [
    { value: 1, label: 'ไม่กำหนดขั้นต่ำ', sortId: 1 } as Dropdown,
    { value: 2, label: 'ประจำหน่วยงาน', sortId: 2 } as Dropdown,
    { value: 3, label: 'ตามจำนวนอัตรากำลังในแต่ละระดับตำแหน่ง', sortId: 4 } as Dropdown,
    { value: 4, label: 'ประจำครุภัณฑ์', sortId: 52 } as Dropdown,
    { value: 5, label: 'ตามจำนวนคนครองในแต่ละระดับตำแหน่ง', sortId: 5 } as Dropdown,
    { value: 6, label: 'ห้องที่ติดตั้งเครื่องปรับอากาศ', sortId: 51 } as Dropdown,
    // { value: 7, label: 'ประจำห้องประชุม' } as Dropdown,
    //{ value: 8, label: 'ประจำฝ่าย/กก. ใต้สังกัด ยกเว้นสถานีตำรวจ' } as Dropdown,
    //{ value: 9, label: 'ประจำงาน' } as Dropdown,
    //{ value: 10, label: 'ประเภทงาน' } as Dropdown,
    //{ value: 11, label: 'จำนวนห้องตามขนาด' } as Dropdown,
    { value: 12, label: 'จำนวนห้องประชุม', sortId: 44 } as Dropdown,
    // { value: 13, label: 'จำนวนเจ้าหน้าที่สายปฎิบัติการ' } as Dropdown,
    // { value: 14, label: 'หน่วยงานที่มีหน่วยงานย่อยในสังกัด หรือออกปฏิบัติงานเป็นทีม ประจำทีม' } as Dropdown,
    { value: 15, label: 'มีกิจกรรมในสถานที่โล่งแจ้ง', sortId: 45 } as Dropdown,
    // { value: 16, label: 'หน่วนงานที่มีหน้าที่ออกไปปฎิบัติสายปฎิบัติการ ตามจำนวนยานพาหนะ' } as Dropdown,
    { value: 17, label: 'จำนวนชั้นของอาคารสำนักงาน', sortId: 46 } as Dropdown,
    { value: 18, label: 'ประจำสายงาน', sortId: 7 } as Dropdown,
    { value: 19, label: 'ประจำตัวเจ้าหน้าที่เวรยาม', sortId: 25 } as Dropdown,
    { value: 20, label: 'ตามภารกิจ', sortId: 36 } as Dropdown,
    { value: 21, label: 'ตามจำนวนคนครองแต่ละสายงาน', sortId: 13 } as Dropdown,
    { value: 22, label: 'ตามจำนวนอัตรากำลังแต่ละสายงาน', sortId: 12 } as Dropdown,
    { value: 23, label: 'ร้อยละคนครองแต่ละสายงาน', sortId: 15 } as Dropdown,
    { value: 24, label: 'ร้อยละอัตรากำลังแต่ละสายงาน', sortId: 14 } as Dropdown,
    // { value: 25, label: 'ประจำยานพาหนะ' } as Dropdown,

    // { value: 40, label: 'ร้อยละ 10 ต่อกำลังพล' } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 2
    // { value: 41, label: 'ร้อยละ 50 ต่อกำลังพล' } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 3
    // { value: 42, label: 'ประจำรถสายตรวจ' } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 4
    // { value: 43, label: 'ประจำรถยนต์ปฏิบัติการสายสืบ' } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 5
    // { value: 44, label: 'ประจำรถยนต์หุ้มเกราะกันกระสุน' } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 6
    // { value: 45, label: 'ประจำหน่วยงาน' } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 7
    { value: 46, label: 'ประจำจุดบริการนักท่องเที่ยว', sortId: 43 } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 8
    { value: 47, label: 'ประจำชุด นปพ.', sortId: 26 } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 9
    { value: 48, label: 'ประจำตัวเจ้าหน้าที่งานจราจร', sortId: 27 } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 10
    { value: 49, label: 'ประจำตัวเจ้าหน้าที่ตำรวจท่องเที่ยวในงานสืบสวน', sortId: 28 } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 11
    { value: 50, label: 'ประจำตัวผู้ทำการในอากาศ', sortId: 29 } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 12
    { value: 51, label: 'ประจำตัวเจ้าหน้าที่รักษาการ', sortId: 30 } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 13
    { value: 52, label: 'ประจำตัวเจ้าหน้าที่ปฏิบัติการในเรือ', sortId: 31 } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 14
    // { value: 53, label: 'ประจำกำลังพล' } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 15
    { value: 54, label: 'หัวหน้าสถานี', sortId: 22 } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 16
    // { value: 55, label: 'หัวหน้าหน่วยงาน' } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 17
    // { value: 56, label: 'หน่วยต่อต้านการก่อการร้าย' } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 18
    // { value: 57, label: 'ประจำอากาศยาน' } as Dropdown, //กรอบพิจารณาจากยุทธภัณฑ์ 19


    // { value: 60, label: 'ภารกิจงานชุมชนสัมพันธ์' } as Dropdown, //กรอบพิจารณาจากยานพาหนะ 2
    // { value: 61, label: 'ประจำภารกิจ' } as Dropdown, //กรอบพิจารณาจากยานพาหนะ 3
    // { value: 62, label: 'ใช้สำหรับภารกิจงานธุรการ' } as Dropdown, //กรอบพิจารณาจากยานพาหนะ 4
    { value: 63, label: 'กำหนดให้มีได้ตามเขตตรวจ', sortId: 47 } as Dropdown, //กรอบพิจารณาจากยานพาหนะ 5
    { value: 64, label: 'ประจำชุดปฏิบัติจราจร', sortId: 54 } as Dropdown, //กรอบพิจารณาจากยานพาหนะ 6
    // { value: 65, label: 'ประจำสายตรวจตำบล' } as Dropdown, //กรอบพิจารณาจากยานพาหนะ 7
    { value: 66, label: 'จำนวนพนักงานสอบสวน', sortId: 23 } as Dropdown, //กรอบพิจารณาจากยานพาหนะ 8
    // { value: 67, label: 'ประจำงานจราจร' } as Dropdown, //กรอบพิจารณาจากยานพาหนะ 9
    // { value: 68, label: 'ตั้งแต่รอง ผกก. จร. ถึงสายตรวจจราจร' } as Dropdown, //กรอบพิจารณาจากยานพาหนะ 10
    // { value: 69, label: 'เกณฑ์ขั้นต่ำ ๕ หมู่บ้าน/1' } as Dropdown, //กรอบพิจารณาจากยานพาหนะ 11
    // { value: 70, label: 'สำหรับภารกิจพิเศษ ' } as Dropdown, //กรอบพิจารณาจากยานพาหนะ 12
    // { value: 71, label: 'ประจำตัว' } as Dropdown, //กรอบพิจารณาจากยานพาหนะ 13
    { value: 72, label: 'ประจำกลุ่มสายงาน', sortId: 6 } as Dropdown, //กรอบพิจารณาจากยานพาหนะ 20
    { value: 73, label: 'กำหนดให้มีได้ตามเขตสืบสวน', sortId: 48 } as Dropdown, //กรอบพิจารณาจากยานพาหนะ 23
    { value: 74, label: 'ประจำยานพาหนะ (มีเงื่อนไข)', sortId: 53 } as Dropdown, //กรอบพิจารณาจากยานพาหนะ 19

    // { value: 80, label: 'ตามความจำเป็น' } as Dropdown, //กรอบพิจารณาจากห้องประชุม ห้องพัก สัมมนา 1
    { value: 81, label: 'ประจำห้องอบรม/สัมมนา', sortId: 49 } as Dropdown, //กรอบพิจารณาจากห้องประชุม ห้องพัก สัมมนา 2
    // { value: 82, label: 'ประจำห้องอบรบ' } as Dropdown, //กรอบพิจารณาจากห้องประชุม ห้องพัก สัมมนา 3
    // { value: 83, label: 'ตามจำนวนผู้ใช้ประโยชน์' } as Dropdown, //กรอบพิจารณาจากห้องประชุม ห้องพัก สัมมนา 4
    // { value: 84, label: 'ตามจำนวนเจ้าหน้าที่ภาคสนาม' } as Dropdown, //กรอบพิจารณาจากห้องประชุม ห้องพัก สัมมนา 5
    { value: 85, label: 'ประจำพื้นที่สันทนาการส่วนรวม', sortId: 50 } as Dropdown, //กรอบพิจารณาจากห้องประชุม ห้องพัก สัมมนา 6

    // { value: 90, label: 'สำหรับหน่วยปฏิบัติ ส.จว.' } as Dropdown, //กรอบพิจารณาจากสันติบาล 1
    // { value: 91, label: 'ประจำฝ่ายควบคุมปฏิบัติ' } as Dropdown, //กรอบพิจารณาจากสันติบาล 3

    // { value: 94, label: 'ประจำหัวหน้าสถานี' } as Dropdown, //กรอบพิจารณาจากศูนย์พิสูจน์หลักฐาน 2

    { value: 95, label: 'ประจำตำแหน่ง', sortId: 3 } as Dropdown, //กรอบพิจารณาจากโรงพยาบาล 1
    // { value: 96, label: 'ตามขนาดห้อง' } as Dropdown, //กรอบพิจารณาจากโรงพยาบาล 3
    // { value: 97, label: 'ประจำห้องประชุม' } as Dropdown, //กรอบพิจารณาจากโรงพยาบาล 4
    { value: 98, label: 'สำหรับรองรับการปฏิบัติราชการของหน่วยงานต่าง ๆ ใน รพ.ตร.', sortId: 42 } as Dropdown, //กรอบพิจารณาจากโรงพยาบาล 5
    { value: 99, label: 'ประจำตำแหน่ง นพ', sortId: 32 } as Dropdown, //กรอบพิจารณาจากโรงพยาบาล 6
    // { value: 100, label: 'ประจำห้องผู้ป่วยและห้องตรวจ' } as Dropdown, //กรอบพิจารณาจากโรงพยาบาล 7
    // { value: 101, label: 'ประจำห้องตรวจ' } as Dropdown, //กรอบพิจารณาจากโรงพยาบาล 8
    // { value: 102, label: 'ประจำหอผู้ป่วยเด็ก' } as Dropdown, //กรอบพิจารณาจากโรงพยาบาล 9
    // { value: 104, label: 'ประจำงานโภชนาการ' } as Dropdown, //กรอบพิจารณาจากโรงพยาบาล 11
    // { value: 105, label: 'ประจำหอผูู้ป่วย' } as Dropdown, //กรอบพิจารณาจากโรงพยาบาล 12

    // { value: 106, label: 'สำหรับภารกิจงานป้องกันและระงับอัคคีภัยในเขต พระราชฐาน' } as Dropdown, //กรอบพิจารณาจากตำรวจตระเวรชายแดน 1
    // { value: 107, label: 'ชุดปฏิบัติการ ป้องกันและระงับอัคคีภัย' } as Dropdown, //กรอบพิจารณาจากตำรวจตระเวรชายแดน 2

    { value: 108, label: 'สำหรับเจ้าหน้าที่สายตรวจและเจ้าหน้าที่ผู้ประสบเหตุ', sortId: 33 } as Dropdown, //กรอบพิจารณาจากยุทธวิถี 1
    // { value: 109, label: 'ต่อยุทธภัณฑ์' } as Dropdown, //กรอบพิจารณาจากยุทธวิถี 4

    { value: 110, label: 'ประจำตัวเจ้าหน้าที่สายปฏิบัติการ', sortId: 34 } as Dropdown, //กรอบพิจารณาจากตรวจคนเข้าเมือง 2

    { value: 111, label: 'ร้อยละเจ้าหน้าที่ปฎิบัติงาน', sortId: 35 } as Dropdown, //เพิ่มขึ้นมาใหม่เพื่อนับร้อยละของกำลังการปฎิบัติงาน
    { value: 112, label: 'ตามขนาดสถานีตำรวจ', sortId: 39 } as Dropdown, //เพิ่มขึ้นมาใหม่

    { value: 113, label: 'ตามจำนวนคนครองแต่ละกลุ่มสายงาน', sortId: 9 } as Dropdown,
    { value: 114, label: 'ตามจำนวนอัตรากำลังแต่ละกลุ่มสายงาน', sortId: 8 } as Dropdown,
    { value: 115, label: 'ร้อยละคนครองแต่ละกลุ่มสายงาน', sortId: 11 } as Dropdown,
    { value: 116, label: 'ร้อยละอัตรากำลังแต่ละกลุ่มสายงาน', sortId: 10 } as Dropdown,

    { value: 117, label: 'ตามจำนวนอัตรากำลังแต่ละยศ', sortId: 16 } as Dropdown,
    { value: 118, label: 'ตามจำนวนคนครองแต่ละยศ', sortId: 17 } as Dropdown,
    { value: 119, label: 'ร้อยละคนครองแต่ละยศ', sortId: 19 } as Dropdown,
    { value: 120, label: 'ร้อยละอัตรากำลังแต่ละยศ', sortId: 18 } as Dropdown,

    { value: 121, label: 'ร้อยละคนครองแต่ละระดับตำแหน่ง', sortId: 21 } as Dropdown,
    { value: 122, label: 'ร้อยละอัตรากำลังแต่ละระดับตำแหน่ง', sortId: 20 } as Dropdown,

    { value: 123, label: 'จำนวนพนักงานสอบสวน (มีเงื่อนไข)', sortId: 24 } as Dropdown,

    { value: 124, label: 'ตามร้อยละจำนวนเจ้าหน้าที่ในภารกิจ', sortId: 38 } as Dropdown,
    { value: 125, label: 'ตามจำนวนเจ้าหน้าที่ในภารกิจ', sortId: 37 } as Dropdown,

    { value: 126, label: 'ตามเขตพื้นที่', sortId: 40 } as Dropdown,
    { value: 127, label: 'ตามเกณฑ์ขั้นต่ำหมู่บ้าน', sortId: 41 } as Dropdown,
    { value: 128, label: 'ประจำฝ่าย/กก.'} as Dropdown,
    { value: 129, label: 'ตามจำนวนรถยนต์ปฏิบัติการสายสืบ' } as Dropdown,
    { value: 130, label: 'ตามจำนวนรถยนต์สายตรวจ' } as Dropdown,

    { value: 131, label: 'ประจำชุดปฏิบัติการ' } as Dropdown,
    { value: 132, label: 'ตามหน่วยงาน' } as Dropdown,

    { value: 133, label: 'ตามจำนวนอัตรากำลังของหน่วยงานภายใต้กำกับ' } as Dropdown,
    { value: 134, label: 'ตามจำนวนคนครองของหน่วยงานภายใต้กำกับ' } as Dropdown,
    { value: 135, label: 'ร้อยละอัตรากำลังของหน่วยงานภายใต้กำกับ' } as Dropdown,
    { value: 136, label: 'ร้อยละคนครองของหน่วยงานภายใต้กำกับ' } as Dropdown,

    { value: 137, label: 'ประจำเจ้าหน้าที่ นปพ.' } as Dropdown,
    { value: 138, label: 'ประจำงาน' } as Dropdown,

    { value: 139, label: 'ตามจำนวนเจ้าหน้าที่ปฎิบัติงาน' } as Dropdown, 

  ]

  agencyGroupSetting = [
    { value: 1, label: 'ข้อมูลหน่วยงาน' } as Dropdown,
    { value: 2, label: 'ที่ทำการและที่พักอาศัย' } as Dropdown,
    { value: 3, label: 'ครุภัณฑ์ทั่วไป' } as Dropdown,
    { value: 4, label: 'ครุภัณฑ์ประจำห้องอบรม สัมมนา ห้องพัก' } as Dropdown,
    { value: 5, label: 'ครุภัณฑ์พิเศษสำหรับสันติบาล' } as Dropdown,
    { value: 6, label: 'ครุภัณฑ์พิเศษสำหรับตรวจคนเข้าเมือง' } as Dropdown,
    { value: 7, label: 'ครุภัณฑ์พิเศษสำหรับศูนย์พิสูจน์หลักฐาน' } as Dropdown,
    { value: 8, label: 'ครุภัณฑ์พิเศษสำหรับโรงพยาบาล' } as Dropdown,
    { value: 9, label: 'ครุภัณฑ์พิเศษสำหรับตำรวจตระเวนชายแดน' } as Dropdown,
    { value: 10, label: 'ครุภัณฑ์ด้านยานพาหนะ' } as Dropdown,
    { value: 11, label: 'ครุภัณฑ์ด้านยุทธภัณฑ์' } as Dropdown,
    { value: 12, label: 'อาวุธและอุปกรณ์เครื่องมือทางยุทธวิธี' } as Dropdown,
    { value: 13, label: 'ครุภัณฑ์' } as Dropdown,
  ]

  agencyGroupSettingDashboard = this.agencyGroupSetting.filter(f => f.value != 1 && f.value != 2);

  manageParcelStatus = [
    { value: 1, label: 'ต่ำกว่ากรอบ' } as Dropdown,
    { value: 2, label: 'ปกติ' } as Dropdown,
    { value: 3, label: 'เกินจำนวนกรอบ' } as Dropdown,
    { value: 4, label: 'ไม่มีขั้นต่ำ' } as Dropdown,
  ];

  armamentTypeList = [
    { value: 1, label: 'ไม่กำหนดขั้นต่ำ' } as Dropdown,
    { value: 2, label: 'ร้อยละ 10 ต่อกำลังพล' } as Dropdown,
    { value: 3, label: 'ร้อยละ 50 ต่อกำลังพล' } as Dropdown,
    { value: 4, label: 'ประจำรถสายตรวจ' } as Dropdown,
    { value: 5, label: 'ประจำรถยนต์ปฏิบัติการสายสืบ' } as Dropdown,
    { value: 6, label: 'ประจำรถยนต์หุ้มเกราะกันกระสุน' } as Dropdown,
    { value: 7, label: 'ประจำหน่วยงาน' } as Dropdown,
    { value: 8, label: 'ประจำจุดบริการนักท่องเที่ยว' } as Dropdown,
    { value: 9, label: 'ประจำชุด นปพ.' } as Dropdown,
    { value: 10, label: 'ประจำตัวเจ้าหน้าที่งานจราจร' } as Dropdown,
    { value: 11, label: 'ประจำตัวเจ้าหน้าที่ตำรวจท่องเที่ยวในงานสืบสวน' } as Dropdown,
    { value: 12, label: 'ประจำตัวผู้ทำการในอากาศ' } as Dropdown,
    { value: 13, label: 'ประจำตัวเจ้าหน้าที่รักษาการณ์' } as Dropdown,
    { value: 14, label: 'ประจำตัวเจ้าหน้าที่ปฏิบัติการในเรือ' } as Dropdown,
    { value: 15, label: 'ประจำกำลังพล' } as Dropdown,
    { value: 16, label: 'หัวหน้าสถานี' } as Dropdown,
    { value: 17, label: 'หัวหน้าหน่วยงาน' } as Dropdown,
    { value: 18, label: 'หน่วยต่อต้านการก่อการร้าย' } as Dropdown,
    { value: 19, label: 'ประจำอากาศยาน' } as Dropdown,

    // { value: 32, label: 'ประจำหน่วยงาน' } as Dropdown,
    { value: 33, label: 'ตามจำนวนอัตรากำลังในแต่ละระดับตำแหน่ง' } as Dropdown,
    // { value: 34, label: 'ประจำครุภัณฑ์' } as Dropdown,
    { value: 35, label: 'ตามจำนวนคนครองในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 36, label: 'ห้องที่ติดตั้งเครื่องปรับอากาศ' } as Dropdown,
    { value: 37, label: 'ประจำห้องประชุม' } as Dropdown,
    { value: 42, label: 'จำนวนห้องประชุม' } as Dropdown,
    { value: 43, label: 'จำนวนเจ้าหน้าที่สายปฎิบัติการ' } as Dropdown,
    { value: 44, label: 'หน่วยงานที่มีหน่วยงานย่อยในสังกัด หรือออกปฏิบัติงานเป็นทีม ประจำทีม' } as Dropdown,
    { value: 45, label: 'มีกิจกรรมในสถานที่โล่งแจ้ง' } as Dropdown,
    { value: 46, label: 'หน่วนงานที่มีหน้าที่ออกไปปฎิบัติสายปฎิบัติการ ตามจำนวนยานพาหนะ' } as Dropdown,
    { value: 47, label: 'จำนวนชั้นของอาคารสำนักงาน' } as Dropdown,
    { value: 48, label: 'ประจำสายงาน (ประจำงาน)' } as Dropdown,
    { value: 49, label: 'ประจำตัวเจ้าหน้าที่เวรยาม' } as Dropdown,
    { value: 50, label: 'ตามภารกิจ' } as Dropdown,
    { value: 51, label: 'ตามจำนวนคนครองแต่ละสายงาน' } as Dropdown,
    { value: 52, label: 'ตามจำนวนอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 53, label: 'ร้อยละคนครองแต่ละสายงาน' } as Dropdown,
    { value: 54, label: 'ร้อยละอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 55, label: 'ประจำยานพาหนะ' } as Dropdown,

  ];

  masterVehicalTypeList = [
    { value: 1, label: 'ประจำหน่วยงาน' } as Dropdown,
    { value: 2, label: 'ภารกิจงานชุมชนสัมพันธ์' } as Dropdown,
    { value: 3, label: 'ประจำภารกิจ' } as Dropdown,
    { value: 4, label: 'ใช้สำหรับภารกิจงานธุรการ' } as Dropdown,
    { value: 5, label: 'กำหนดให้มีได้ตามเขตตรวจ' } as Dropdown,
    { value: 6, label: 'ประจำชุดปฏิบัติจราจร' } as Dropdown,
    { value: 7, label: 'ประจำสายตรวจตำบล' } as Dropdown,
    { value: 8, label: 'จำนวนพนักงานสอบสวน' } as Dropdown,
    { value: 9, label: 'ประจำงานจราจร' } as Dropdown,
    { value: 10, label: 'ตั้งแต่รอง ผกก. จร. ถึงสายตรวจจราจร' } as Dropdown,
    { value: 11, label: 'เกณฑ์ขั้นต่ำ ๕ หมู่บ้าน/1' } as Dropdown,
    { value: 12, label: 'สำหรับภารกิจพิเศษ ' } as Dropdown,
    { value: 13, label: 'ประจำตัว' } as Dropdown,
    { value: 14, label: 'ไม่กำหนดขั้นต่ำ' } as Dropdown,
    { value: 15, label: 'ตามจำนวนอัตรากำลังในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 16, label: 'ตามจำนวนคนครองในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 17, label: 'ร้อยละคนครองแต่ละสายงาน' } as Dropdown,
    { value: 18, label: 'ร้อยละอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 19, label: 'ประจำยานพาหนะ' } as Dropdown,
    { value: 20, label: 'ประจำกลุ่มสายงาน' } as Dropdown,
    // { value: 21, label: 'ประจำหน่วยงาน' } as Dropdown,
    { value: 22, label: 'ประจำสายงาน (ประจำงาน)' } as Dropdown,
    { value: 23, label: 'กำหนดให้มีได้ตามเขตสืบสวน' } as Dropdown,

    // { value: 32, label: 'ประจำหน่วยงาน' } as Dropdown,
    // { value: 33, label: 'ตามจำนวนอัตรากำลังในแต่ละระดับตำแหน่ง' } as Dropdown,
    // { value: 34, label: 'ประจำครุภัณฑ์' } as Dropdown,
    // { value: 35, label: 'ตามจำนวนคนครองในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 36, label: 'ห้องที่ติดตั้งเครื่องปรับอากาศ' } as Dropdown,
    { value: 37, label: 'ประจำห้องประชุม' } as Dropdown,
    { value: 42, label: 'จำนวนห้องประชุม' } as Dropdown,
    { value: 43, label: 'จำนวนเจ้าหน้าที่สายปฎิบัติการ' } as Dropdown,
    { value: 44, label: 'หน่วยงานที่มีหน่วยงานย่อยในสังกัด หรือออกปฏิบัติงานเป็นทีม ประจำทีม' } as Dropdown,
    { value: 45, label: 'มีกิจกรรมในสถานที่โล่งแจ้ง' } as Dropdown,
    { value: 46, label: 'หน่วนงานที่มีหน้าที่ออกไปปฎิบัติสายปฎิบัติการ ตามจำนวนยานพาหนะ' } as Dropdown,
    { value: 47, label: 'จำนวนชั้นของอาคารสำนักงาน' } as Dropdown,
    // { value: 48, label: 'ประจำสายงาน (ประจำงาน)' } as Dropdown,
    { value: 49, label: 'ประจำตัวเจ้าหน้าที่เวรยาม' } as Dropdown,
    { value: 50, label: 'ตามภารกิจ' } as Dropdown,
    { value: 51, label: 'ตามจำนวนคนครองแต่ละสายงาน' } as Dropdown,
    { value: 52, label: 'ตามจำนวนอัตรากำลังแต่ละสายงาน' } as Dropdown,
    // { value: 53, label: 'ร้อยละคนครองแต่ละสายงาน' } as Dropdown,
    // { value: 54, label: 'ร้อยละอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 55, label: 'ประจำยานพาหนะ' } as Dropdown,

  ];

  masterMeetingTypeList = [
    { value: 1, label: 'ตามความจำเป็น' } as Dropdown,
    { value: 2, label: 'ประจำห้องอบรม/สัมมนา' } as Dropdown,
    { value: 3, label: 'ประจำห้องอบรบ' } as Dropdown,
    { value: 4, label: 'ตามจำนวนผู้ใช้ประโยชน์' } as Dropdown,
    { value: 5, label: 'ตามจำนวนเจ้าหน้าที่ภาคสนาม' } as Dropdown,
    { value: 6, label: 'ประจำพื้นที่สันทนาการส่วนรวม' } as Dropdown,
    { value: 7, label: 'ไม่กำหนดขั้นต่ำ' } as Dropdown,

    { value: 32, label: 'ประจำหน่วยงาน' } as Dropdown,
    { value: 33, label: 'ตามจำนวนอัตรากำลังในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 34, label: 'ประจำครุภัณฑ์' } as Dropdown,
    { value: 35, label: 'ตามจำนวนคนครองในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 36, label: 'ห้องที่ติดตั้งเครื่องปรับอากาศ' } as Dropdown,
    { value: 37, label: 'ประจำห้องประชุม' } as Dropdown,
    { value: 42, label: 'จำนวนห้องประชุม' } as Dropdown,
    { value: 43, label: 'จำนวนเจ้าหน้าที่สายปฎิบัติการ' } as Dropdown,
    { value: 44, label: 'หน่วยงานที่มีหน่วยงานย่อยในสังกัด หรือออกปฏิบัติงานเป็นทีม ประจำทีม' } as Dropdown,
    { value: 45, label: 'มีกิจกรรมในสถานที่โล่งแจ้ง' } as Dropdown,
    { value: 46, label: 'หน่วนงานที่มีหน้าที่ออกไปปฎิบัติสายปฎิบัติการ ตามจำนวนยานพาหนะ' } as Dropdown,
    { value: 47, label: 'จำนวนชั้นของอาคารสำนักงาน' } as Dropdown,
    { value: 48, label: 'ประจำสายงาน (ประจำงาน)' } as Dropdown,
    { value: 49, label: 'ประจำตัวเจ้าหน้าที่เวรยาม' } as Dropdown,
    { value: 50, label: 'ตามภารกิจ' } as Dropdown,
    { value: 51, label: 'ตามจำนวนคนครองแต่ละสายงาน' } as Dropdown,
    { value: 52, label: 'ตามจำนวนอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 53, label: 'ร้อยละคนครองแต่ละสายงาน' } as Dropdown,
    { value: 54, label: 'ร้อยละอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 55, label: 'ประจำยานพาหนะ' } as Dropdown,

  ];

  masterSpecialBranchTypeList = [
    { value: 1, label: 'สำหรับหน่วยปฏิบัติ ส.จว.' } as Dropdown,
    { value: 2, label: 'ประจำหน่วยงาน' } as Dropdown,
    { value: 3, label: 'ประจำฝ่ายควบคุมปฏิบัติ' } as Dropdown,
    { value: 4, label: 'ไม่กำหนดขั้นต่ำ' } as Dropdown,

    // { value: 32, label: 'ประจำหน่วยงาน' } as Dropdown,
    { value: 33, label: 'ตามจำนวนอัตรากำลังในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 34, label: 'ประจำครุภัณฑ์' } as Dropdown,
    { value: 35, label: 'ตามจำนวนคนครองในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 36, label: 'ห้องที่ติดตั้งเครื่องปรับอากาศ' } as Dropdown,
    { value: 37, label: 'ประจำห้องประชุม' } as Dropdown,
    { value: 42, label: 'จำนวนห้องประชุม' } as Dropdown,
    { value: 43, label: 'จำนวนเจ้าหน้าที่สายปฎิบัติการ' } as Dropdown,
    { value: 44, label: 'หน่วยงานที่มีหน่วยงานย่อยในสังกัด หรือออกปฏิบัติงานเป็นทีม ประจำทีม' } as Dropdown,
    { value: 45, label: 'มีกิจกรรมในสถานที่โล่งแจ้ง' } as Dropdown,
    { value: 46, label: 'หน่วนงานที่มีหน้าที่ออกไปปฎิบัติสายปฎิบัติการ ตามจำนวนยานพาหนะ' } as Dropdown,
    { value: 47, label: 'จำนวนชั้นของอาคารสำนักงาน' } as Dropdown,
    { value: 48, label: 'ประจำสายงาน (ประจำงาน)' } as Dropdown,
    { value: 49, label: 'ประจำตัวเจ้าหน้าที่เวรยาม' } as Dropdown,
    { value: 50, label: 'ตามภารกิจ' } as Dropdown,
    { value: 51, label: 'ตามจำนวนคนครองแต่ละสายงาน' } as Dropdown,
    { value: 52, label: 'ตามจำนวนอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 53, label: 'ร้อยละคนครองแต่ละสายงาน' } as Dropdown,
    { value: 54, label: 'ร้อยละอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 55, label: 'ประจำยานพาหนะ' } as Dropdown,

  ];

  masterEvidenceCenterTypeList = [
    { value: 1, label: 'ประจำหน่วยงงาน' } as Dropdown,
    { value: 2, label: 'ประจำหัวหน้าสถานี' } as Dropdown,
    { value: 3, label: 'ไม่กำหนดขั้นต่ำ' } as Dropdown,

    // { value: 32, label: 'ประจำหน่วยงาน' } as Dropdown,
    { value: 33, label: 'ตามจำนวนอัตรากำลังในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 34, label: 'ประจำครุภัณฑ์' } as Dropdown,
    { value: 35, label: 'ตามจำนวนคนครองในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 36, label: 'ห้องที่ติดตั้งเครื่องปรับอากาศ' } as Dropdown,
    { value: 37, label: 'ประจำห้องประชุม' } as Dropdown,
    { value: 42, label: 'จำนวนห้องประชุม' } as Dropdown,
    { value: 43, label: 'จำนวนเจ้าหน้าที่สายปฎิบัติการ' } as Dropdown,
    { value: 44, label: 'หน่วยงานที่มีหน่วยงานย่อยในสังกัด หรือออกปฏิบัติงานเป็นทีม ประจำทีม' } as Dropdown,
    { value: 45, label: 'มีกิจกรรมในสถานที่โล่งแจ้ง' } as Dropdown,
    { value: 46, label: 'หน่วนงานที่มีหน้าที่ออกไปปฎิบัติสายปฎิบัติการ ตามจำนวนยานพาหนะ' } as Dropdown,
    { value: 47, label: 'จำนวนชั้นของอาคารสำนักงาน' } as Dropdown,
    { value: 48, label: 'ประจำสายงาน (ประจำงาน)' } as Dropdown,
    { value: 49, label: 'ประจำตัวเจ้าหน้าที่เวรยาม' } as Dropdown,
    { value: 50, label: 'ตามภารกิจ' } as Dropdown,
    { value: 51, label: 'ตามจำนวนคนครองแต่ละสายงาน' } as Dropdown,
    { value: 52, label: 'ตามจำนวนอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 53, label: 'ร้อยละคนครองแต่ละสายงาน' } as Dropdown,
    { value: 54, label: 'ร้อยละอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 55, label: 'ประจำยานพาหนะ' } as Dropdown,

  ];

  masterHospitalTypeList = [
    { value: 1, label: 'ประจำตำแหน่ง' } as Dropdown,
    { value: 2, label: 'ประจำหน่วยงาน.' } as Dropdown,
    { value: 3, label: 'ตามขนาดห้อง' } as Dropdown,
    { value: 4, label: 'ประจำห้องประชุม' } as Dropdown,
    { value: 5, label: 'สำหรับรองรับการปฏิบัติราชการของหน่วยงานต่าง ๆ ใน รพ.ตร.' } as Dropdown,
    { value: 6, label: 'ประจำตำแหน่ง นพ' } as Dropdown,
    { value: 7, label: 'ประจำห้องผู้ป่วยและห้องตรวจ' } as Dropdown,
    { value: 8, label: 'ประจำห้องตรวจ' } as Dropdown,
    { value: 9, label: 'ประจำหอผู้ป่วยเด็ก' } as Dropdown,
    { value: 10, label: 'ประจำครุภัณฑ์' } as Dropdown,
    { value: 11, label: 'ประจำงานโภชนาการ' } as Dropdown,
    { value: 12, label: 'ประจำหอผูู้ป่วย' } as Dropdown,
    { value: 13, label: 'ไม่กำหนดขั้นต่ำ' } as Dropdown,

    // { value: 32, label: 'ประจำหน่วยงาน' } as Dropdown,
    { value: 33, label: 'ตามจำนวนอัตรากำลังในแต่ละระดับตำแหน่ง' } as Dropdown,
    // { value: 34, label: 'ประจำครุภัณฑ์' } as Dropdown,
    { value: 35, label: 'ตามจำนวนคนครองในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 36, label: 'ห้องที่ติดตั้งเครื่องปรับอากาศ' } as Dropdown,
    // { value: 37, label: 'ประจำห้องประชุม' } as Dropdown,
    { value: 42, label: 'จำนวนห้องประชุม' } as Dropdown,
    { value: 43, label: 'จำนวนเจ้าหน้าที่สายปฎิบัติการ' } as Dropdown,
    { value: 44, label: 'หน่วยงานที่มีหน่วยงานย่อยในสังกัด หรือออกปฏิบัติงานเป็นทีม ประจำทีม' } as Dropdown,
    { value: 45, label: 'มีกิจกรรมในสถานที่โล่งแจ้ง' } as Dropdown,
    { value: 46, label: 'หน่วนงานที่มีหน้าที่ออกไปปฎิบัติสายปฎิบัติการ ตามจำนวนยานพาหนะ' } as Dropdown,
    { value: 47, label: 'จำนวนชั้นของอาคารสำนักงาน' } as Dropdown,
    { value: 48, label: 'ประจำสายงาน (ประจำงาน)' } as Dropdown,
    { value: 49, label: 'ประจำตัวเจ้าหน้าที่เวรยาม' } as Dropdown,
    { value: 50, label: 'ตามภารกิจ' } as Dropdown,
    { value: 51, label: 'ตามจำนวนคนครองแต่ละสายงาน' } as Dropdown,
    { value: 52, label: 'ตามจำนวนอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 53, label: 'ร้อยละคนครองแต่ละสายงาน' } as Dropdown,
    { value: 54, label: 'ร้อยละอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 55, label: 'ประจำยานพาหนะ' } as Dropdown,

  ];

  masterBorderPatrolTypeList = [
    { value: 1, label: 'สำหรับภารกิจงานป้องกันและระงับอัคคีภัยในเขต พระราชฐาน' } as Dropdown,
    { value: 2, label: 'ชุดปฏิบัติการ ป้องกันและระงับอัคคีภัย' } as Dropdown,
    { value: 3, label: 'ไม่กำหนดขั้นต่ำ' } as Dropdown,

    { value: 32, label: 'ประจำหน่วยงาน' } as Dropdown,
    { value: 33, label: 'ตามจำนวนอัตรากำลังในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 34, label: 'ประจำครุภัณฑ์' } as Dropdown,
    { value: 35, label: 'ตามจำนวนคนครองในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 36, label: 'ห้องที่ติดตั้งเครื่องปรับอากาศ' } as Dropdown,
    { value: 37, label: 'ประจำห้องประชุม' } as Dropdown,
    { value: 42, label: 'จำนวนห้องประชุม' } as Dropdown,
    { value: 43, label: 'จำนวนเจ้าหน้าที่สายปฎิบัติการ' } as Dropdown,
    { value: 44, label: 'หน่วยงานที่มีหน่วยงานย่อยในสังกัด หรือออกปฏิบัติงานเป็นทีม ประจำทีม' } as Dropdown,
    { value: 45, label: 'มีกิจกรรมในสถานที่โล่งแจ้ง' } as Dropdown,
    { value: 46, label: 'หน่วนงานที่มีหน้าที่ออกไปปฎิบัติสายปฎิบัติการ ตามจำนวนยานพาหนะ' } as Dropdown,
    { value: 47, label: 'จำนวนชั้นของอาคารสำนักงาน' } as Dropdown,
    { value: 48, label: 'ประจำสายงาน (ประจำงาน)' } as Dropdown,
    { value: 49, label: 'ประจำตัวเจ้าหน้าที่เวรยาม' } as Dropdown,
    { value: 50, label: 'ตามภารกิจ' } as Dropdown,
    { value: 51, label: 'ตามจำนวนคนครองแต่ละสายงาน' } as Dropdown,
    { value: 52, label: 'ตามจำนวนอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 53, label: 'ร้อยละคนครองแต่ละสายงาน' } as Dropdown,
    { value: 54, label: 'ร้อยละอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 55, label: 'ประจำยานพาหนะ' } as Dropdown,

  ];

  masterTacticalTypeList = [
    { value: 1, label: 'สำหรับเจ้าหน้าที่สายตรวจและเจ้าหน้าที่ผู้ประสบเหตุ' } as Dropdown,
    { value: 2, label: 'ประจำยานพาหนะ' } as Dropdown,
    { value: 3, label: 'ประจำหน่วยงาน' } as Dropdown,
    { value: 4, label: 'ต่อยุทธภัณฑ์' } as Dropdown,
    { value: 5, label: 'ไม่กำหนดขั้นต่ำ' } as Dropdown,

    // { value: 32, label: 'ประจำหน่วยงาน' } as Dropdown,
    { value: 33, label: 'ตามจำนวนอัตรากำลังในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 34, label: 'ประจำครุภัณฑ์' } as Dropdown,
    { value: 35, label: 'ตามจำนวนคนครองในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 36, label: 'ห้องที่ติดตั้งเครื่องปรับอากาศ' } as Dropdown,
    { value: 37, label: 'ประจำห้องประชุม' } as Dropdown,
    { value: 42, label: 'จำนวนห้องประชุม' } as Dropdown,
    { value: 43, label: 'จำนวนเจ้าหน้าที่สายปฎิบัติการ' } as Dropdown,
    { value: 44, label: 'หน่วยงานที่มีหน่วยงานย่อยในสังกัด หรือออกปฏิบัติงานเป็นทีม ประจำทีม' } as Dropdown,
    { value: 45, label: 'มีกิจกรรมในสถานที่โล่งแจ้ง' } as Dropdown,
    { value: 46, label: 'หน่วนงานที่มีหน้าที่ออกไปปฎิบัติสายปฎิบัติการ ตามจำนวนยานพาหนะ' } as Dropdown,
    { value: 47, label: 'จำนวนชั้นของอาคารสำนักงาน' } as Dropdown,
    { value: 48, label: 'ประจำสายงาน (ประจำงาน)' } as Dropdown,
    { value: 49, label: 'ประจำตัวเจ้าหน้าที่เวรยาม' } as Dropdown,
    { value: 50, label: 'ตามภารกิจ' } as Dropdown,
    { value: 51, label: 'ตามจำนวนคนครองแต่ละสายงาน' } as Dropdown,
    { value: 52, label: 'ตามจำนวนอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 53, label: 'ร้อยละคนครองแต่ละสายงาน' } as Dropdown,
    { value: 54, label: 'ร้อยละอัตรากำลังแต่ละสายงาน' } as Dropdown,

  ];

  masterImmigrationTypeList = [
    { value: 1, label: 'ประจำหน่วยงาน' } as Dropdown,
    { value: 2, label: 'ประจำตัวเจ้าหน้าที่สายปฏิบัติการ' } as Dropdown,
    { value: 3, label: 'ไม่กำหนดขั้นต่ำ' } as Dropdown,

    // { value: 32, label: 'ประจำหน่วยงาน' } as Dropdown,
    { value: 33, label: 'ตามจำนวนอัตรากำลังในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 34, label: 'ประจำครุภัณฑ์' } as Dropdown,
    { value: 35, label: 'ตามจำนวนคนครองในแต่ละระดับตำแหน่ง' } as Dropdown,
    { value: 36, label: 'ห้องที่ติดตั้งเครื่องปรับอากาศ' } as Dropdown,
    { value: 37, label: 'ประจำห้องประชุม' } as Dropdown,
    { value: 42, label: 'จำนวนห้องประชุม' } as Dropdown,
    { value: 43, label: 'จำนวนเจ้าหน้าที่สายปฎิบัติการ' } as Dropdown,
    { value: 44, label: 'หน่วยงานที่มีหน่วยงานย่อยในสังกัด หรือออกปฏิบัติงานเป็นทีม ประจำทีม' } as Dropdown,
    { value: 45, label: 'มีกิจกรรมในสถานที่โล่งแจ้ง' } as Dropdown,
    { value: 46, label: 'หน่วนงานที่มีหน้าที่ออกไปปฎิบัติสายปฎิบัติการ ตามจำนวนยานพาหนะ' } as Dropdown,
    { value: 47, label: 'จำนวนชั้นของอาคารสำนักงาน' } as Dropdown,
    { value: 48, label: 'ประจำสายงาน (ประจำงาน)' } as Dropdown,
    { value: 49, label: 'ประจำตัวเจ้าหน้าที่เวรยาม' } as Dropdown,
    { value: 50, label: 'ตามภารกิจ' } as Dropdown,
    { value: 51, label: 'ตามจำนวนคนครองแต่ละสายงาน' } as Dropdown,
    { value: 52, label: 'ตามจำนวนอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 53, label: 'ร้อยละคนครองแต่ละสายงาน' } as Dropdown,
    { value: 54, label: 'ร้อยละอัตรากำลังแต่ละสายงาน' } as Dropdown,
    { value: 55, label: 'ประจำยานพาหนะ' } as Dropdown,

  ];

  buildingTypeList = [
    { value: 1, label: 'ที่ทำการ' } as Dropdown,
    { value: 2, label: 'ที่พักอาศัย' } as Dropdown,
    { value: 3, label: 'โรงพยาบาล' } as Dropdown,
  ]

  tempExampleList = [
    { value: 1, label: 'ทดสอบ 1' } as Dropdown,
    { value: 2, label: 'ทดสอบ 2' } as Dropdown,
    { value: 3, label: 'ทดสอบ 3' } as Dropdown,
  ]

  buildingResidenceUsageStatus = [
    { value: 1, label: 'ปกติ' } as Dropdown,
    { value: 2, label: 'เลิกใช้งาน' } as Dropdown,
    { value: 3, label: 'ซ่อมแซม' } as Dropdown,
  ];

  buildingResidenceRoomStatus = [
    { value: 1, label: 'มีผู้ใช้งาน' } as Dropdown,
    { value: 2, label: 'ว่าง' } as Dropdown,
  ];

  manageAgencyMenu = [
    { value: 1, label: 'จัดการข้อมูลหน่วยงาน' } as Dropdown,
    //{ value: 2, label: 'จัดการข้อมูลหน่วยงานในสังกัด' } as Dropdown,
  ];

  requestEquipmentStatus = [
    { value: 1, label: 'ร่าง' } as Dropdown,
    { value: 2, label: 'รออนุมัติ' } as Dropdown,
    { value: 3, label: 'อนุมัติ' } as Dropdown,
    { value: 4, label: 'ปฎิเสธ' } as Dropdown,
  ];

  manageParcalStatus = [
    { value: 1, label: 'ใช้งานได้' } as Dropdown,
    { value: 2, label: 'ซ่อมแชม' } as Dropdown,
    { value: 2, label: 'จำหน่าย' } as Dropdown,
  ];

  conditionAmountType = [
    { value: 1, label: 'น้อยกว่า' } as Dropdown,
    { value: 2, label: 'มากกว่า' } as Dropdown,
  ]

  dashboardFilter = [
    { value: 1, label: 'ประจำหน่วย' } as Dropdown,
    { value: 2, label: 'ประจำกาย' } as Dropdown,
    { value: 3, label: 'รายการของกลุ่มสืบสวนสอบสวน' } as Dropdown,
  ]

  operationalStaffOptions = [
    { value: 1, label: 'ผู้ทำการในอากาศ' },
    { value: 2, label: 'เจ้าหน้าที่รักษาการ' },
    { value: 3, label: 'เจ้าหน้าที่ปฏิบัติการในเรือ' },
    { value: 4, label: 'เจ้าหน้าที่ควบคุมปฏิบัติการ' },
    { value: 5, label: 'หัวหน้าสถานี' },
    { value: 6, label: 'หัวหน้าหน่วยงาน' },
    { value: 7, label: 'พนักงานสอบสวนในแต่ละผลัด' },
    { value: 8, label: 'เจ้าหน้าที่ภาคสนาม' },
    { value: 9, label: 'ชุด นปพ.' },
    { value: 10, label: 'เจ้าหน้าที่งานจราจร' },
    { value: 11, label: 'เจ้าหน้าที่ตำรวจท่องเที่ยวในงานสืบสวน' },
    { value: 12, label: 'สายตรวจตำบล' },
    { value: 13, label: 'เจ้าหน้าที่เวรยาม' },
    { value: 14, label: 'เจ้าหน้าที่ นปพ.' }
  ] as Dropdown[];

  areaOption = [
    { value: 1, label: 'ติดน้ำ' },
    { value: 2, label: 'ติดชายทะเล' },
    { value: 3, label: 'ติดพื้นที่เขา' },
    { value: 4, label: 'ถูกภัยซ้ำซาก' },
    { value: 5, label: 'ติดแม่น้ำ' },
    { value: 6, label: 'พื้นที่ชายทะเลและป่าชาย' }
  ] as Dropdown[];
  
  getMstEquipmentQuotaTypeList(){
    return this.MstEquipmentQuotaTypeList
      .slice()
      .sort((a, b) => {
        const aSort = a.sortId ?? Number.MAX_SAFE_INTEGER;
        const bSort = b.sortId ?? Number.MAX_SAFE_INTEGER;

        return aSort - bSort;
      });
  }


  getRequestEquipmentStatus(index: number): string {
    var getValue = this.requestEquipmentStatus.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  getAgencyGroupSettingDetail(index: number): string {
    var getValue = this.agencyGroupSetting.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  getArmamentEquipmentTypeDetail(index: number): string {
    var getValue = this.armamentTypeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  getVehicalEquipmentTypeDetail(index: number): string {
    var getValue = this.masterVehicalTypeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  getMeetingEquipmentTypeDetail(index: number): string {
    var getValue = this.masterMeetingTypeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  getSpecialBranchEquipmentTypeDetail(index: number): string {
    var getValue = this.masterSpecialBranchTypeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  getEvidenceCenterEquipmentTypeDetail(index: number): string {
    var getValue = this.masterEvidenceCenterTypeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  getHospitalEquipmentTypeDetail(index: number): string {
    var getValue = this.masterHospitalTypeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  getBorderPatrolEquipmentTypeDetail(index: number): string {
    var getValue = this.masterBorderPatrolTypeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }


  getTacticalEquipmentTypeDetail(index: number): string {
    var getValue = this.masterTacticalTypeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  getImmigrationEquipmentTypeDetail(index: number): string {
    var getValue = this.masterImmigrationTypeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  getManageParcelStatusDetail(index: number): string {
    var getValue = this.manageParcalStatus.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }


  get getAgencyTierList(): Dropdown[] { //ระดับหน่วยงาน
    return this.tierList;
  }


  get getAgencyTierListForDashboard(): Dropdown[] { //ระดับหน่วยงาน
    return this.tierList.filter(f => f.value != 11);
  }

  get getAgencyTierListBackward(): Dropdown[] { //ระดับหน่วยงาน
    return this.tierList.sort((s, e) => (s.value > e.value ? -1 : 1));
  }

  get getAgencyTierListChildLevel(): Dropdown[] { //ระดับหน่วยงาน
    return this.tierListChild;
  }

  agencyTierDetail(index: number): string {
    var getValue = this.tierList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  get getAgencyTypeList(): Dropdown[] { //ประเภทหน่วยงาน
    return this.typeList;
  }

  agencyTypeDetail(index: number) {
    
    var getValue = this.typeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  get getStationSizeList(): Dropdown[] { //ขนาดสถานีตำรวจ
    return this.stationSizeList;
  }

  stationSizeDetail(index: number) {
    var getValue = this.stationSizeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  get getImmigrationSizeList(): Dropdown[] { //ระดับตรวจคนเข้าเมือง
    return this.immigrationSizeList;
  }

  immigrationSizeDetail(index: number) {
    var getValue = this.immigrationSizeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  get getEvidenceCenterSizeList(): Dropdown[] { //ระดับศูนย์พิสจน์หลักฐาน
    return this.evidenceCenterSizeList;
  }

  evidenceCenterSizeDetail(index: number) {
    var getValue = this.evidenceCenterSizeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  get getOtherSizeList(): Dropdown[] { //ระดับหน่วยงานอื่นๆ
    return this.otherSizeList;
  }

  otherSizeDetail(index: number) {
    var getValue = this.otherSizeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  fieldTypeDetail(index: number) {
    var getValue = this.fieldTypeList.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  manageParcelStatusDetail(index: number) {
    var getValue = this.manageParcelStatus.find(f => f.value == index);
    if (getValue) {
      return getValue.label;
    }
    return "-";
  }

  get getAgencyGroupSettingForDashboard(): Dropdown[]  {
    return this.agencyGroupSettingDashboard;
  }

  getOrganizations(): Observable<Organization[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<Organization[]>(
      `${environment.api}/api/Common/Organizations`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getDivisions(organizationId: number): Observable<Division[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<Division[]>(
      `${environment.api}/api/Common/Organizations/${organizationId}/Divisions`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getSubdivisions(divisionId: number): Observable<Subdivision[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<Subdivision[]>(
      `${environment.api}/api/Common/Divisions/${divisionId}/Subdivisions`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getAllSubdivisions(): Observable<Subdivision[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<Subdivision[]>(
      `${environment.api}/api/Common/Subdivisions`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getDepartments(subdivisionId: number): Observable<Department[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<Department[]>(
      `${environment.api}/api/Common/Subdivisions/${subdivisionId}/Departments`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getRanks(): Observable<Rank[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<Rank[]>(
      `${environment.api}/api/Common/Ranks`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getGender(): Observable<Gender[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<Gender[]>(
      `${environment.api}/api/Common/Gender`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getField(): Observable<Field[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<Field[]>(
      `${environment.api}/api/Common/Field`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getClasses(): Observable<Classes[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<Classes[]>(
      `${environment.api}/api/Common/Classes`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getFieldGroup(): Observable<FieldGroup[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<FieldGroup[]>(
      `${environment.api}/api/Common/FieldGroup`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getPosition(): Observable<Position[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<Position[]>(
      `${environment.api}/api/Common/Position`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getEquipmentType(): Observable<EquipmentType[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<EquipmentType[]>(
      `${environment.api}/api/Common/EquipmentType`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getEquipmentTypeById(equipmentId: number): Observable<EquipmentType> {
    this.isLoadingSubject.next(true);
    return this.http.get<EquipmentType>(
      `${environment.api}/api/Common/EquipmentTypeById?equipmentTypeId=${equipmentId}`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getUnit(): Observable<Unit[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<Unit[]>(
      `${environment.api}/api/Common/Unit`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getFiscalYear(): Observable<FiscalYear[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<FiscalYear[]>(
      `${environment.api}/api/Common/FiscalYear`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getMainArmamentCategory(): Observable<MainArmamentCategory[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<MainArmamentCategory[]>(
      `${environment.api}/api/Common/MainArmamentCategory`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getSubArmamentCategory(mainArmamentCategoryId?:number): Observable<SubArmamentCategory[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<SubArmamentCategory[]>(
      `${environment.api}/api/Common/SubArmamentCategory?mainArmamentCategoryId=${mainArmamentCategoryId}`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  GetSubArmamentCategoryFromMaemt(maemtId: number): Observable<SubArmamentCategory[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<SubArmamentCategory[]>(
      `${environment.api}/api/Common/GetSubArmamentCategoryFromMaemt?maemtId=${maemtId}`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  GetArmamentTypeForMaesc(maescId: number): Observable<ArmamentType[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<ArmamentType[]>(
      `${environment.api}/api/Common/GetArmamentTypeForMaesc?maescId=${maescId}`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getArmamentTypeById(armamentId: number): Observable<ArmamentType> {
    this.isLoadingSubject.next(true);
    return this.http.get<ArmamentType>(
      `${environment.api}/api/Common/ArmamentTypeById?armamentTypeId=${armamentId}`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getArmamentType(mainArmamentCategoryId?: number, subArmamentCategoryId?: number): Observable<ArmamentType[]> {
    let param = new HttpParams();
    if (mainArmamentCategoryId) {
      param = param.set("mainArmamentCategoryId", mainArmamentCategoryId);
    }
    if (subArmamentCategoryId) {
      param = param.set("subArmamentCategoryId", subArmamentCategoryId);
    }
    this.isLoadingSubject.next(true);
    return this.http.get<ArmamentType[]>(
      `${environment.api}/api/Common/ArmamentType`, { params: param }
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getMainVehicalTypeById(vehicalTypeId: number): Observable<MainVehicalType> {
    this.isLoadingSubject.next(true);
    return this.http.get<MainVehicalType>(
      `${environment.api}/api/Common/GetMainVehicalTypeById?vehicalTypeId=${vehicalTypeId}`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getMainVehicalType(): Observable<MainVehicalType[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<MainVehicalType[]>(
      `${environment.api}/api/Common/GetMainVehicalType`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getMaterialTypeById(materialTypeId: number): Observable<MaterialType> {
    this.isLoadingSubject.next(true);
    return this.http.get<MaterialType>(
      `${environment.api}/api/Common/GetMaterialTypeById?materialTypeId=${materialTypeId}`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getMaterialType(): Observable<MaterialType[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<MaterialType[]>(
      `${environment.api}/api/Common/GetMaterialType`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getProvince(): Observable<Province[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<Province[]>(
      `${environment.api}/api/Common/GetProvince`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getDistrict(provinceId: number): Observable<District[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<District[]>(
      `${environment.api}/api/Common/GetDistrict?provinceId=${provinceId}`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getSubDistrict(districtId: number): Observable<Subdistrict[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<Subdistrict[]>(
      `${environment.api}/api/Common/GetSubDistrict?districtId=${districtId}`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  initialAttachment(): FormGroup {
    const form = this.fb.group({
      originalFileName: [null],
      generateFileName: [null],
      fileSize: [null],
      fileExtension: [null],
    });
    return form;
  }

  assignAttachment(formArray: FormArray, result: MasterAttachment[], formArray$: BehaviorSubject<FormArray>): void {
    result?.forEach((attachmentResult, idx) => {
      if (formArray?.controls?.find(e => e.get('generateFileName')?.value === attachmentResult.generateFileName)) {
        return;
      }
      formArray.push(this.initialAttachment());
      formArray.at(idx).patchValue(attachmentResult);
    });
    formArray$.next(formArray);
  }

  isFormInvalid(formGroup: FormGroup, formControlName: string): boolean {
    return (formGroup.controls[formControlName].touched || formGroup.controls[formControlName].dirty) && formGroup.controls[formControlName].invalid
  }

  getProcurementType(): Observable<ProcurementType[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<ProcurementType[]>(
      `${environment.api}/api/Common/ProcurementType`
    ).pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getOperationStaffLabel(value: number): string{
    const staff = this.operationalStaffOptions.find(item => item.value === value);
    return staff ? staff.label : '-';
  };
}
